import ApiClient, { apiClient, ApiError } from "@/utils/api";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

type UseApiMutationOptions<OutputType, InputType> = UseMutationOptions<OutputType, ApiError, InputType>

export type ApiMutation<OutputType, InputType> = Omit<UseApiMutationOptions<OutputType, InputType>, 'mutationFn'> & {
    mutationFn: (apiClient: ApiClient, input: InputType) => Promise<OutputType>
}

export function useApiMutation<OutputType, InputType>(mutation: ApiMutation<OutputType, InputType>) {
    return useMutation({
        ...mutation,
        mutationFn: (input) => mutation.mutationFn(apiClient, input),
    })
}